<template>
    <svg width="20" height="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 471.213 471.213" xml:space="preserve">
        <path :fill="props.color"></path>
        <polygon :fill="props.color" points="450,113.11 471.213,91.897 379.316,0 358.104,21.213 393.445,56.555 351.22,98.78 294.671,42.231 273.458,63.444

298.199,88.186 255.007,131.378 297.421,173.792 276.208,195.005 233.794,152.591 190.679,195.707 233.093,238.12 211.88,259.333 

169.466,216.919 127.765,258.621 170.179,301.034 148.966,322.247 106.552,279.833 52.83,333.555 84.638,365.362 0,450 

21.213,471.213 105.851,386.575 137.658,418.382 383.027,173.014 407.769,197.755 428.981,176.542 372.432,119.993 414.658,77.768 

" />
    </svg>
</template>


<script setup>

import { defineProps } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: 'rgb(var(--locumate-primary-color))',
    },
});

</script>